export default function overrideIfMinBetNumberEnabled(overrideFn) {
    if (!overrideFn) {
        return;
    }
    if (!IsMBNIndicatorEnabled) {
        return;
    }
    overrideFn();
}
//# sourceMappingURL=index.js.map